import { Edit } from '@mui/icons-material';
import { Box, Chip, Grid, IconButton, Paper, Typography } from '@mui/material';
import { validatePermissions } from 'lib/functions/utils';
import React from 'react';
import { User } from 'services/redux/authSlice';

import EconomicSection from './components/EconomicSection';
import GeneralSection from './components/GeneralSection';
import LocationSection from './components/LocationSection';

interface SummaryProps {
  setEditing: (editing: boolean) => void;
  user: User | undefined;
  businessIdentifier: string | null;
  email: string | null;
  region: string | null;
  province: string | null;
  commune: string | null;
  address: string | null;
  economicSector: string | null;
  economicSubSector: string | null;
  economicActivity: string | null;
  salesSegment: string | null;
}

const Summary: React.FC<SummaryProps> = (props) => {
  const {
    setEditing,
    user,
    businessIdentifier,
    email,
    region,
    province,
    commune,
    address,
    economicSector,
    economicSubSector,
    economicActivity,
    salesSegment,
  } = props;
  const canEdit = validatePermissions(user, 'businesses_create_new');

  return (
    <Paper
      sx={{
        p: 3,
        boxShadow: 'none',
        border: '1px solid #e0e0e0',
        position: 'relative',
        marginTop: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 3,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: 'text.primary',
              fontSize: '1.2rem',
              lineHeight: 1.1,
            }}
          >
            Información de la Empresa
          </Typography>
          <Chip
            label="Resumen"
            size="small"
            color="primary"
            variant="outlined"
            sx={{ height: '22px', fontSize: '0.75rem' }}
          />
        </Box>
        {canEdit && (
          <IconButton
            size="small"
            onClick={() => setEditing(true)}
            sx={{
              padding: 1,
              backgroundColor: 'rgba(25, 118, 210, 0.1)',
              '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.2)',
              },
            }}
          >
            <Edit sx={{ fontSize: '1rem', color: 'primary.main' }} />
          </IconButton>
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <GeneralSection
            businessIdentifier={businessIdentifier}
            email={email}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <LocationSection
            region={region}
            province={province}
            commune={commune}
            address={address}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <EconomicSection
            economicSector={economicSector}
            economicSubSector={economicSubSector}
            economicActivity={economicActivity}
            salesSegment={salesSegment}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Summary;
